import { module }from 'stereomodularjs';
export default class extends module {
    constructor(m) {
        super(m);
        this.firstInit = true,
        this.events = {
            click: 'overlayOpen'
        }
    }

    init(){
        let thisEl = this.el
        let overlayContents = document.querySelectorAll('[data-overlay="content"]')
        if(this.firstInit){
            overlayContents.forEach(content => {
                toggleChildsTabindex(content, '-1')
                //console.log(content)
            })
            this.firstInit = false
        }
        
    }

    overlayOpen() {
        let thisEl = this.el

        // Reset class for accessibility focus back
        if(document.querySelector('.js-overlay-focus-back')){
            classRemove(document.querySelector('.js-overlay-focus-back'),'js-overlay-focus-back')
        }

        // Set class for accessibility focus back
        classAdd(thisEl,'js-overlay-focus-back')

        // Set aria-hidden
        //document.querySelector('.js-overlay-content').setAttribute('aria-hidden','false')

        // Add class to HTML enabling Overlay
        classAdd(document.querySelector('html'),'is-overlay-active')

        // Scope overlay class
        let overlayPanel = document.querySelector(thisEl.getAttribute('data-overlay'))
        //document.querySelector(overlayPanel).setAttribute('aria-hidden','false')
        toggleChildsTabindex(overlayPanel, '0')

        // Set current overlay content active
        overlayPanel.classList.add('is-active')

        // If content is video append it to video container
        if (thisEl.getAttribute('data-video')) {
            let overlayVideo = thisEl.getAttribute('data-video')
            document.querySelector('.js-overlay-video').innerHTML = overlayVideo
        }

        // Set focus on quick close
        document.activeElement.blur()
        document.querySelector('.js-accessibility-close').focus()

        let closeButtons = document.querySelectorAll('.js-overlay__close')
        closeButtons.forEach(button => {
            toggleChildsTabindex(button, '0')
        })

        
    }
}
/*
    Support multiple overlays

    USAGE : TRIGGERS

    For video embed :
    <button class="o-button" role="dialog" data-module="Overlay" data-overlay=".js-overlay-content-1" data-video='<iframe width="560" height="315" src="https://www.youtube.com/embed/Z6IgWL7nKi4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' aria-label="Afficher la vidéo en superposition">Afficher la vidéo</button>
    For text :
    <button class="o-button" role="dialog" data-module="Overlay" data-overlay=".js-overlay-content-3" aria-label="Afficher le formulaire d'infolettre">Afficher le formulaire d'infolettre</button>

    USAGE : HTML MARKUP

    <div class="c-overlay-wrap">
        <div class="c-overlay-content js-overlay-content">
			<button class="js-overlay__close js-accessibility-close" role="button" aria-hidden="true" data-module="OverlayClose">Fermer l'affichage supperposé</button>
            <div class="c-overlay-content__item js-overlay-content-1" data-overlay="content">
                <div class="c-overlay-video js-overlay-video"></div>
            </div>
            <div class="c-overlay-content__item js-overlay-content-2" data-overlay="content">
                <div class="o-text">
                    <h1>Titre</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit...</p>
					<a href="" class="o-button">Lien</a>
                </div>
            </div>
			<div class="c-overlay-content__item js-overlay-content-3" data-overlay="content">
                <div class="o-text">
                    <h3>Newsletter</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit...</p>
					<form action="#">
						<input type="email" name="email" placeholder="Email">
						<button type="button">Soumettre</button>
					</form>
                </div>
            </div>
        </div>
		<div class="c-overlay__bg js-overlay__close" role="button" data-module="OverlayClose">
			<button class="c-overlay__close" aria-label="Fermer le message supperposé"></button>
		</div>
    </div>	

*/